import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { UserMasterService } from "../../Services/user-master.service";
import { UserMaster } from "../../Model/user-master";
import { NgxSmartModalService } from "ngx-smart-modal";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from "@angular/forms";
import { IMyDpOptions } from "mydatepicker";
import { ModalInstance } from "ngx-smart-modal/src/services/modal-instance";
import { UserMasterValidators } from "./user-master-validators";
import { map } from "rxjs/operators";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { of } from "rxjs";
import { ComponentSecurityService } from "src/app/Main/Services/component-security.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-user-master-revisions",
  templateUrl: "./user-master-revisions.component.html",
  styleUrls: ["./user-master-revisions.component.css"]
})
export class UserMasterRevisionsComponent implements OnInit {
  public factors: UserMaster[];
  public columnDefs = [];
  public rowData = [];
  private gridApi;
  private gridColumnApi;
  private gridOptions;
  private defaultColDef;
  private rowSelection;
  private crudAction;
  public form: FormGroup;
  public canUpdateForm: boolean;
  public clicked: boolean = false;
  public userMaster1 = [];

  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: "Today",
    dateFormat: "mm/dd/yyyy",
    sunHighlight: true,
    inline: false,
    firstDayOfWeek: "su",
    editableDateField: false
  };

  constructor(
    private service: UserMasterService,
    public ngxSmartModalService: NgxSmartModalService,
    private userMasterValidators: UserMasterValidators,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private securityService: ComponentSecurityService
  ) {
    this.defaultColDef = { sortable: true, filter: true };
    this.rowSelection = "single";
    this.createFormGroup();
    this.createGridColumnDefs();
  }

  @ViewChild("userID", { static: true }) userIDField: ElementRef;

  ngOnInit() {
    // Get grid data
    this.service.getAll().subscribe(
      response => {
        if (response.length > 0) {
          this.rowData = response;
        } else {
          this.rowData = null;
          this.toastr.warning("No records found", "Warning");
        }
      },
      error => {
        this.toastr.error("Unexpected error occurred", "Error");
      }
    );

    // Get form security
    this.securityService
      .canUpdate(this.constructor.name, localStorage.getItem("user"))
      .subscribe(
        response => {
          if (response.length > 0) this.canUpdateForm = true;
          else {
            this.canUpdateForm = false;
            this.form.controls["birthday"].disable();
            this.form.controls["anniversary"].disable();
            this.form.controls["hireDate"].disable();
          }
        },
        error => {
          this.canUpdateForm = false;
          this.form.controls["birthday"].disable();
          this.form.controls["anniversary"].disable();
          this.form.controls["hireDate"].disable();
        }
      );
    // Get dropdown values
    this.loadDropDownValues();
  }

  createFormGroup() {
    this.form = this.fb.group(
      {
        type: new FormControl(""),
        userID: new FormControl(null, [Validators.required]),
        name: new FormControl(null, [Validators.required]),
        password: new FormControl(null, [Validators.required]),
        department: new FormControl(""),
        title: new FormControl(""),
        birthday: new FormControl(""),
        anniversary: new FormControl(""),
        hireDate: new FormControl(""),
        poReqAprLimit: new FormControl(""),
        poReqApproverID: new FormControl(""),
        emailAddress: new FormControl(""),
        defaultOutQ: new FormControl(""),
        changeID: new FormControl(""),
        lastUpdated: new FormControl(""),
        id: new FormControl("")
      },
      {
        validator: this.userMasterValidators.shouldBeUnique.bind(this)
      }
    );
  }

  createGridColumnDefs() {
    this.columnDefs = [
      { headerName: "id", field: "id", hide: true },
      { headerName: "changeID", field: "changeID", hide: true },
      { headerName: "lastUpdated", field: "lastUpdated", hide: true },
      {
        headerName: "User ID",
        field: "userID",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "User Name",
        field: "name",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "Department",
        field: "department",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "Title",
        field: "title",
        filter: "agTextColumnFilter"
      },
      { headerName: "type", field: "type", hide: true },
      { headerName: "password", field: "password", hide: true },
      { headerName: "birthday", field: "birthday", hide: true },
      { headerName: "anniversary", field: "anniversary", hide: true },
      { headerName: "hireDate", field: "hireDate", hide: true },
      { headerName: "poReqAprLimit", field: "poReqAprLimit", hide: true },
      { headerName: "poReqApproverID", field: "poReqApproverID", hide: true },
      { headerName: "emailAddress", field: "emailAddress", hide: true },
      { headerName: "defaultOutQ", field: "defaultOutQ", hide: true }
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    setTimeout(() => this.userIDField.nativeElement.focus());
  }

  onSelectionChanged(event) {
    // only open the window of row selected
    if (event.node.selected) {
      this.ngxSmartModalService.setModalData(
        this.gridApi.getSelectedRows()[0],
        "myModal",
        true
      );
      this.clearDate();
      this.setDate();
      this.crudAction = "Update";
      this.loadInitialFormValues();
      this.ngxSmartModalService.getModal("myModal").open();
      setTimeout(() => this.userIDField.nativeElement.focus());
    }

    // capture the event, so deselectall can be call when window closed
    this.gridOptions = event;
  }

  export() {
    let params = {
      fileName: "UserMaster",
      allColumns: true
    };
    this.gridApi.exportDataAsExcel(params);
  }

  loadDropDownValues() {
    // Get boolean dropdown values from UDC
    // This could change to other master tables, depending on how the dropdown is loaded
    this.service.getAll().subscribe(
      response => {
        if (response.length > 0) {
          this.userMaster1 = response;
        } else {
          this.userMaster1 = null;
        }
      },
      error => {
        this.userMaster1 = null;
      }
    );
  }

  loadInitialFormValues() {
    // If field is loading a zero, make it blanks
    this.form.patchValue({
      type: this.gridApi.getSelectedRows()[0]["type"],
      userID: this.gridApi.getSelectedRows()[0]["userID"],
      name: this.gridApi.getSelectedRows()[0]["name"],
      password: this.gridApi.getSelectedRows()[0]["password"],
      department: this.gridApi.getSelectedRows()[0]["department"],
      title: this.gridApi.getSelectedRows()[0]["title"],
      poReqAprLimit: this.gridApi.getSelectedRows()[0]["poReqAprLimit"],
      poReqApproverID: this.gridApi.getSelectedRows()[0]["poReqApproverID"],
      emailAddress: this.gridApi.getSelectedRows()[0]["emailAddress"],
      defaultOutQ: this.gridApi.getSelectedRows()[0]["defaultOutQ"],
      changeID: this.gridApi.getSelectedRows()[0]["changeID"],
      lastUpdated: this.gridApi.getSelectedRows()[0]["lastUpdated"],
      id: this.gridApi.getSelectedRows()[0]["id"]
    });
    this.clicked = false;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  setDate(): void {
    // Set date based on DB value if not null
    if (
      typeof this.ngxSmartModalService.getModalData("myModal") != "undefined"
    ) {
      
      if (
        this.ngxSmartModalService.getModalData("myModal").birthday !=
        "0001-01-01"
      ) {
        let fullDate =
          this.ngxSmartModalService.getModalData("myModal").birthday +
          "T00:00:00";
        let date = new Date(fullDate);
        this.form.patchValue({
          birthday: {
            date: {
              year: date.getFullYear(),
              month: date.getMonth() + 1,
              day: date.getDate()
            }
          }
        });
      }

      if (
        this.ngxSmartModalService.getModalData("myModal").anniversary !=
        "0001-01-01"
      ) {
        let fullDate =
          this.ngxSmartModalService.getModalData("myModal").anniversary +
          "T00:00:00";
        let date = new Date(fullDate);
        this.form.patchValue({
          anniversary: {
            date: {
              year: date.getFullYear(),
              month: date.getMonth() + 1,
              day: date.getDate()
            }
          }
        });
      }

      if (
        this.ngxSmartModalService.getModalData("myModal").hireDate !=
        "0001-01-01"
      ) {
        let fullDate =
          this.ngxSmartModalService.getModalData("myModal").hireDate +
          "T00:00:00";
        let date = new Date(fullDate);
        this.form.patchValue({
          hireDate: {
            date: {
              year: date.getFullYear(),
              month: date.getMonth() + 1,
              day: date.getDate()
            }
          }
        });
      }
    }
  }


  clearDate(): void {
    // Clear the date using the patchValue function
    this.form.patchValue({ birthday: null, aniversary: null, hireDate: null });
  }

  modalAction() {
    switch (this.crudAction) {
      case "Update":
        this.service
          .update(
            this.form.value,
            this.ngxSmartModalService.getModalData("myModal").id
          )
          .subscribe(
            response => {
              if (response["success"] == "true")
                this.toastr.success("Record updated", "Success");
              this.service.getAll().subscribe(data => {
                this.rowData = data;
                this.gridApi.setRowData(this.rowData);
              });
            },
            error => {
              this.toastr.error("Record not updated", "Error");
            }
          );
        this.ngxSmartModalService.get("myModal").close();
        break;
      case "Create":
        this.service.create(this.form.value).subscribe(
          response => {
            if (response["success"] == "true")
              this.toastr.success("New record added", "Success");
            this.service.getAll().subscribe(data => {
              this.rowData = data;
              this.gridApi.setRowData(this.rowData);
            });
          },
          error => {
            this.toastr.error("Record not added", "Error");
          }
        );
        this.ngxSmartModalService.get("myModal").close();

        break;
      case "Delete":
        this.service
          .delete(this.ngxSmartModalService.getModalData("myModal").id)
          .subscribe(
            response => {
              this.toastr.success("Record deleted", "Success");
              this.service.getAll().subscribe(data => {
                this.rowData = data;
                this.gridApi.setRowData(this.rowData);
              });
            },
            error => {
              this.toastr.error("Record not deleted", "Error");
            }
          );
        this.ngxSmartModalService.get("myModal").close();
        break;
    }
  }

  close() {
    if (typeof this.gridOptions != "undefined")
      this.gridOptions.api.deselectAll();
  }

  create() {
    this.crudAction = "Create";
    this.ngxSmartModalService.resetModalData("myModal");
    this.form.reset();
    this.clicked=false;
    this.ngxSmartModalService.getModal("myModal").open();
    setTimeout(() => this.userIDField.nativeElement.focus());
  }

  // delete() {
    // this.crudAction = "Delete";
    // if (window.confirm("Are sure you want to delete this item ?")) {
      // this.modalAction();
    // } else {
      // this.ngxSmartModalService.get("myModal").close();
    // }
  // }

  delete() {
    this.crudAction = "Delete";
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then(result => {
      if (result.value) {
        this.modalAction();
      }
    });
  }
}
